import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, HeartIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function SolutionSection() {
  return <section className="py-20 bg-white md:py-32" data-id="element-194">
      <div className="px-4 mx-auto max-w-5xl sm:px-6 lg:px-8" data-id="element-195">
        {/* Solución Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="mb-24 text-center" data-id="element-196">
          <motion.div variants={itemVariants} className="mb-10 max-w-md mx-auto" data-id="element-197">
            <img src="https://cdn.magicpatterns.com/uploads/nz9U1oe6otGBLuP7vJbF5H/Gemini_Generated_Image_5zwrax5zwrax5zwr.png" alt="Organiza Tu Vida en 10 Minutos al Día" className="w-full h-auto shadow-2xl rounded-3xl" data-id="element-198" />
          </motion.div>
          <motion.span variants={itemVariants} className="block mb-4 text-sm font-bold tracking-widest uppercase text-warm-green" data-id="element-199">
            Aquí es donde entra este sistema.
          </motion.span>
          <motion.h2 variants={itemVariants} className="mb-6 text-3xl font-bold md:text-5xl text-charcoal font-playfair" data-id="element-200">
            PRODUCTIVIDAD REAL PARA <br className="hidden md:block" data-id="element-201" />
            <span className="text-sage" data-id="element-202">MAMÁS Y MUJERES OCUPADAS</span>
          </motion.h2>
          <motion.p variants={itemVariants} className="max-w-2xl mx-auto mb-12 text-lg text-charcoal/80" data-id="element-203">
            Un sistema simple de 30 días que te enseña a:
          </motion.p>

          <div className="grid max-w-3xl grid-cols-1 gap-4 mx-auto mb-12 md:grid-cols-2 text-left" data-id="element-204">
            {['Reducir el caos mental', 'Organizar tu semana sin estrés', 'Saber exactamente qué hacer cada día', 'Liberarte de la culpa constante', 'Recuperar claridad y control'].map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-center p-4 bg-beige rounded-2xl" data-id="element-205">
                <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 mr-4 bg-white rounded-full shadow-sm" data-id="element-206">
                  <CheckIcon className="w-5 h-5 text-warm-green" data-id="element-207" />
                </div>
                <span className="font-medium text-charcoal" data-id="element-208">{item}</span>
              </motion.div>)}
          </div>

          <motion.div variants={itemVariants} className="inline-block px-8 py-4 bg-sage-light/20 rounded-full" data-id="element-209">
            <p className="text-xl font-bold text-sage-dark font-playfair" data-id="element-210">
              Todo usando un método de solo 10 minutos diarios.
            </p>
          </motion.div>
        </motion.div>

        {/* Imagen de transición */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 max-w-3xl mx-auto overflow-hidden rounded-3xl shadow-md" data-id="element-211">
          <img src="https://cdn.magicpatterns.com/uploads/oLq6Je8j2huk4ixGV2nfDM/Gemini_Generated_Image_f2a9tyf2a9tyf2a9.png" alt="Mamá organizada escribiendo en su cuaderno" className="w-full h-auto object-cover" data-id="element-212" />
        </motion.div>

        {/* Beneficios Section */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-8" data-id="element-213">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={containerVariants} className="p-8 md:p-10 bg-beige-warm rounded-3xl" data-id="element-214">
            <motion.h3 variants={itemVariants} className="mb-8 text-2xl font-bold text-charcoal font-playfair" data-id="element-215">
              Después de aplicar este sistema podrás:
            </motion.h3>
            <div className="space-y-6" data-id="element-216">
              {['Dejar de sentir que todo es urgente', 'Organizar tus días sin saturarte', 'Reducir tu estrés mental', 'Tener tiempo para lo importante', 'Volver a sentir que tienes control sobre tu vida'].map((benefit, index) => <motion.div key={index} variants={itemVariants} className="flex items-start" data-id="element-217">
                  <HeartIcon className="flex-shrink-0 w-6 h-6 mr-4 text-sage mt-0.5" data-id="element-218" />
                  <p className="text-lg text-charcoal/90" data-id="element-219">{benefit}</p>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={containerVariants} className="p-8 border-2 md:p-10 border-beige rounded-3xl" data-id="element-220">
            <motion.h3 variants={itemVariants} className="mb-8 text-2xl font-bold text-charcoal font-playfair" data-id="element-221">
              Este sistema funciona incluso si:
            </motion.h3>
            <div className="space-y-6" data-id="element-222">
              {['Trabajas tiempo completo', 'Tienes hijos pequeños', 'Tu casa siempre está llena de cosas por hacer', 'Sientes que tu mente está siempre saturada'].map((condition, index) => <motion.div key={index} variants={itemVariants} className="flex items-start" data-id="element-223">
                  <div className="flex items-center justify-center flex-shrink-0 w-6 h-6 mr-4 rounded-full bg-warm-green/20 mt-0.5" data-id="element-224">
                    <CheckIcon className="w-4 h-4 text-warm-green" data-id="element-225" />
                  </div>
                  <p className="text-lg text-charcoal/90" data-id="element-226">{condition}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}